import { GetBannerCarouselApiParameter, GetBannerCarouselModel, getBannerCarousel } from "@NA/Services/GetBannerCarousel";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";


type HandlerType = CustomApiHandler<GetBannerCarouselApiParameter, GetBannerCarouselModel>;

export const DispatchBannerCarousel: HandlerType = (props: any) => {
    props.dispatch({
        type: "HomePage/GetBannerCarousel",
        result: props.parameter,
    });
};

export const LoadBannerCarousel: HandlerType = async (props: any) => {
    props.apiResult  = await getBannerCarousel(props.parameter) ;
    
};


export const DispatchCompleteLoadBannerCarousel: HandlerType = props => {
    props.dispatch({
        type: "Homepage/DispatchCompleteLoadBannerCarousel",
        bannerCarousel: props.apiResult
    });
};

export const chain = [DispatchBannerCarousel, LoadBannerCarousel, DispatchCompleteLoadBannerCarousel];

const bannerCarousel = createHandlerChainRunnerOptionalParameter(chain, {
    isPreview: false,
    pageUrl: ""
}, "bannerCarousel");
export default bannerCarousel;
